export default "<p>\r\n  third-collection works!\r\n</p>\r\n"